import React, { Component } from 'react';
import Grid from "@material-ui/core/Grid";
import { Button, withStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, Link, Typography, TablePagination } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@material-ui/lab";
import DeleteIcon from "@material-ui/icons/Delete";
import { TableSortLabel } from "@material-ui/core";
import AuthenticationService from "../../Services/AuthenticationService.js";
import LoadingMsgBar from "../LoadingMsgBar.js";
import GlobalMessage from "../GlobalMessage.js";
import './ManageRosterSourcesForUserGroup.css';

const styles = () => ({
    root: {
        width: '100%',
    },
    // container: {
    //     marginTop: '10px',
    //     marginBottom: '10px',
    // },
    button: {
        margin: '10px',
    },
    orText: {
        //margin: '0 10px',
        fontWeight: 'bold',
        textAlign: 'center',
        fontSize: '16px'
    },
    formField: {
        marginBottom: '10px'
    },

    tableContainer: {
        marginTop: '30px',
        marginBottom: '30px',
        border: '1px solid #e0e0e0', // Add border to entire table
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)' // Add subtle shadow for depth
    },
    tableHeader: {
        backgroundColor: '#003168', // Changed from #f5f5f5 to blue color
        fontWeight: 'bold'
    },
    tableCell: {
        padding: '8px 8px',
        borderRight: '1px solid #e0e0e0', // Add vertical separator line
        '&:last-child': {
            borderRight: 'none' // Remove border from last column
        }
    },
    headerCell: {
        padding: '14px 16px',
        fontWeight: 'bold',
        color: '#ffffff', // Changed from #333 to white for better contrast with blue background
        borderRight: '1px solid #1a4d80', // Add lighter blue separator for headers
        '&:last-child': {
            borderRight: 'none' // Remove border from last column
        }
    },
    noDataMessage: {
        padding: '20px',
        textAlign: 'center',
        fontStyle: 'italic',
        color: '#666'
    },
    dialogTitle: {
        // backgroundColor: '#003168',
        // color: '#ffffff',
        padding: '16px 24px'
    },
    viewLink: {
        cursor: 'pointer',
        textDecoration: 'underline',
        '&:hover': {
            textDecoration: 'none'
        }
    },
    pagination: {
        borderTop: '1px solid #e0e0e0',
        marginTop: '8px'
    },
    topPagination: {
        borderBottom: '1px solid #e0e0e0',
        marginBottom: '8px'
    },
    filterRow: {
        backgroundColor: '#ffffff !important', // Normal grid row background color with !important
        '& .MuiTableCell-root': {
            backgroundColor: '#ffffff !important', // Ensure cells also have white background
            borderBottom: '1px solid rgba(224, 224, 224, 1)'
        }
    },
    filterCell: {
        padding: '1px 1px',
        borderRight: '1px solid #e0e0e0',
        backgroundColor: '#ffffff !important',
        '&:last-child': {
            borderRight: 'none'
        }
    }
});

window.analytics = { pageName: 'Manage Roster Hub Sources For User Group' };

// Helper function for sorting
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function descendingComparator(a, b, orderBy) {
    const valueA = a[orderBy] !== null ? String(a[orderBy]).toUpperCase() : '';
    const valueB = b[orderBy] !== null ? String(b[orderBy]).toUpperCase() : '';
    
    if (valueB < valueA) {
        return -1;
    }
    if (valueB > valueA) {
        return 1;
    }
    return 0;
}

class ManageRosterSourcesForUserGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            previousScreen: null,
            userDetailsInfo: null,
            progMsg: '',
            successMsg: '',
            errorMsg: '',
            loadingMessage: '',
            isCreateUserButtonEnabled: true,
            isSaveDraftButtonEnabled: false,
            isAddButtonEnabled: false, // ADD button starts disabled
            isSaveInProgress: false, // Track when save operation is in progress
            mode: 'unknown', // Can be 'newGroup' or 'existingGroup'
            //sourceNames: [], // Array for roster hub source names
            sourcesData: [], // Full data for roster sources
            selectedSourceName: null,
            groupIds: [], // TO DO deprecate
            groupsData: [], // Full data for provider hub groups
            selectedGroupId: null,
            sourceNameError: '',
            groupIdError: '',
            grpInfoId: null,
            groupSourceIdList: [], // Array to store just the sourceIds for data transfer and state maintenance
            sourceMap: {}, // Map of sourceIds (as strings) to source objects for faster lookups
            isDialogOpen: false, // Flag to control the modal dialog visibility
            currentSourceId: null, // Current source ID for which groups are displayed
            currentSourceName: '', // Current source name for dialog title
            currentProviderGroups: [], // Current provider groups to display in dialog
            filteredProviderGroups: [], // Filtered provider groups based on search criteria
            filters: {
                sourceGroupId: '',
                grpName: '',
                adminGroupFlag: ''
            }, // Filter values for each column
            page: 0, // Current page for provider groups pagination
            rowsPerPage: 5, // Number of rows per page for provider groups table
            sourcesPage: 0, // Current page for roster hub sources pagination
            sourcesRowsPerPage: 5, // Number of rows per page for roster hub sources table
            filteredGroupSourceList: [], // Filtered roster hub sources based on search criteria (renamed from filteredAddedGroups)
            sourcesFilters: {
                sourceId: '',
                sourceName: ''
            }, // Filter values for roster hub sources table
            providerGroupOrder: 'asc',
            providerGroupOrderBy: 'grpId' // Default sort by Provider Group ID
        };
    }

    componentDidMount() {
        console.log('ManageRosterSourcesForUserGroup - componentDidMount - props:', this.props.location?.state);
        
        // Get the user details and state from the previous screen
        if (this.props.location && this.props.location.state) {
            const locationState = this.props.location.state;
            
            // Set mode if provided in location state
            if (locationState.mode) {
                this.setState({ mode: locationState.mode });
                console.log(`Mode set to: ${locationState.mode}`);

                // If in existingGroup mode and groupInfo is passed, fetch the group's roster sources
                if (locationState.mode === 'existingGroup' && locationState.groupInfo) {
                    this.loadUserRosterSources(locationState.groupInfo);
                }
                // Handle draft users when coming from AddUser - they also need to load existing roster sources
                else if (locationState.mode === 'draftGroup' && locationState.groupInfo) {
                    console.log('Draft user group detected, loading roster sources from groupInfo');
                    this.loadUserRosterSources(locationState.groupInfo);
                }
            } else {
                console.log(`No mode provided in location state, using default: ${this.state.mode}`);
            }
            
            // Handle data passed from AddUser using our new consistent format
            if (locationState.formData) {
                // Store form data as previousScreen for backwards compatibility
                this.setState({ previousScreen: locationState.formData });
                console.log('Form data received:', locationState.formData);
                
                // If there are previously selected roster sources in the form data, use them
                if (locationState.formData.selectedRosterSources && 
                    locationState.formData.selectedRosterSources.length > 0) {
                    
                    // Extract sourceIds from the complete roster sources objects
                    const sourceIds = locationState.formData.selectedRosterSources.map(source => source.sourceId);
                    this.setState({ groupSourceIdList: sourceIds });
                    console.log('Restored previously selected roster sources:', sourceIds);
                }
            }
            // Backwards compatibility with the old structure
            else if (locationState.previousScreen) {
                this.setState({ previousScreen: locationState.previousScreen });
                console.log('Previous screen data (legacy format):', locationState.previousScreen);
            } 
            // Handle data from UserSearch
            else if (locationState.user) {
                const userData = locationState.user;
                this.setState({ previousScreen: userData });
                console.log('User data received from UserSearch:', userData);
            }
        }

        // Get the current logged-in user details
        this.getUser();

        // Load roster sources and handle previously selected sources
        this.loadRosterSourcesAndGroups();
    }
    
    // Method to fetch and load user's roster sources (for both existingGroup and draftGroup modes)
    loadUserRosterSources = (groupInfo) => {
        console.log('Loading user roster sources with groupInfo:', groupInfo);
        
        if (!groupInfo) {
            console.error('No groupInfo provided to loadUserRosterSources');
            return;
        }
        
        // Extract and validate roster sources
        const rosterSources = groupInfo.groupRosterSources || [];
        console.log('Found roster sources in groupInfo:', rosterSources);
        
        if (rosterSources.length === 0) {
            console.warn('No roster sources found in groupInfo.groupRosterSources');
        }
        
        // Extract only the sourceId values from each roster source
        const userRosterSources = rosterSources.map(rs => {
            // Handle different possible formats of roster source data
            if (typeof rs === 'object') {
                return rs.sourceId;
            }
            return rs; // In case it's already just the ID
        });
        
        console.log('Extracted sourceIds from roster sources:', userRosterSources);
        
        // Determine which ID to use - check both possible property names
        let groupId = null;
        if (groupInfo.grpInfoId !== undefined) {
            groupId = groupInfo.grpInfoId;
            console.log('Using grpInfoId:', groupId);
        } else if (groupInfo.groupInfoId !== undefined) {
            groupId = groupInfo.groupInfoId;
            console.log('Using groupInfoId:', groupId);
        } else {
            console.error('No group ID found in groupInfo:', groupInfo);
        }
        
        // Update state with the user's roster sources (just sourceId values)
        this.setState({ 
            groupSourceIdList: userRosterSources,
            grpInfoId: groupId
        }, () => {
            console.log(`State updated with ${userRosterSources.length} roster source(s) and groupId: ${groupId}`);
        });
    }
    
    // Method to dynamically generate groupSourceList from groupSourceIdList and sourcesData
    getGroupSourceList = () => {
        const { groupSourceIdList, sourcesData, sourceMap } = this.state;
        
        if (!groupSourceIdList || groupSourceIdList.length === 0) {
            return [];
        }
        
        if (!sourceMap || Object.keys(sourceMap).length === 0) {
            // Fallback if sourceMap is not populated yet, but we shouldn't reach this case
            if (!sourcesData || sourcesData.length === 0) {
                return [];
            }
            
            // Create temporary map if needed
            const tempMap = {};
            sourcesData.forEach(source => {
                if (source && source.sourceId !== undefined) {
                    tempMap[String(source.sourceId)] = source;
                }
            });
            
            // Map each sourceId using temporary map
            return this._mapSourceIdsToObjects(groupSourceIdList, tempMap);
        }
        
        // Use the sourceMap from state for direct, efficient lookups
        return this._mapSourceIdsToObjects(groupSourceIdList, sourceMap);
    }
    
    // Helper method to map source IDs to their full objects
    _mapSourceIdsToObjects = (sourceIds, sourceMap) => {
        return sourceIds.map(sourceId => {
            // Ensure sourceId is a string for consistent lookup
            const sourceIdStr = String(sourceId);
            
            console.log('Mapping sourceId:', sourceId, 'as string:', sourceIdStr);
            
            // Use the map for direct lookup
            const matchedSource = sourceMap[sourceIdStr];
            console.log('Matched source:', matchedSource);
            
            if (matchedSource) {
                return {
                    id: sourceIdStr, // Unique ID for the row
                    sourceId: matchedSource.sourceId,
                    sourceName: matchedSource.sourceName,
                    providerGroups: 'N/A' // Default value for provider groups
                };
            }
            
            // Fallback if no matching source is found
            console.log('No match found for sourceId:', sourceIdStr, 'using fallback');
            return {
                id: sourceIdStr,
                sourceId: sourceIdStr,
                sourceName: 'Unknown Source',
                providerGroups: 'N/A'
            };
        });
    }

    loadRosterSourcesAndGroups = () => {
        // Set loading message
        this.setState({ loadingMessage: 'Please wait while we retrieve data.' });
        
        // Create promises for both API calls
        const sourcesPromise = AuthenticationService.getAllRosterSources();
        const sourceGroupsPromise = AuthenticationService.getAllRosterSourceGroups();
        
        // Execute both API calls in parallel
        Promise.all([sourcesPromise, sourceGroupsPromise])
            .then(([sourcesResponse, sourceGroupsResponse]) => {
                // Process roster sources
                //let sourceNames = [];
                let sourcesData = [];
                if (sourcesResponse.data && sourcesResponse.data.length > 0) {
                    sourcesData = sourcesResponse.data;

                    // sourceNames = Array.from(
                    //     new Set(
                    //         sourcesData
                    //             .map(source => source.sourceName || '')
                    //             .filter(Boolean)
                    //     )
                    // ).sort((a, b) => a.localeCompare(b));
                }
                
                // Process roster source groups
                let groupIds = [];
                let groupsData = [];
                if (sourceGroupsResponse.data && sourceGroupsResponse.data.length > 0) {
                    groupsData = sourceGroupsResponse.data;
                    groupIds = groupsData
                        .map(group => group.sourceGroupId || '')
                        .filter(Boolean)
                        .map(id => String(id)); // Ensure all IDs are strings
                }
                
                // Check for previously selected roster sources using our consistent data path
                const locationState = this.props.location && this.props.location.state;
                let initialAddedGroups = [];
                let selectedRosterSources = null;
                
                // Get roster sources from the consistent formData path
                if (locationState && locationState.formData && 
                    locationState.formData.selectedRosterSources && 
                    locationState.formData.selectedRosterSources.length > 0) {
                    
                    selectedRosterSources = locationState.formData.selectedRosterSources;
                    console.log('Found roster sources in formData:', selectedRosterSources);
                } 
                // Legacy support for old paths
                else if (locationState && locationState.selectedRosterSources) {
                    selectedRosterSources = locationState.selectedRosterSources;
                    console.log('Found roster sources in legacy location:', selectedRosterSources);
                }
                else if (locationState && locationState.previousScreen && 
                         locationState.previousScreen.selectedRosterSources) {
                    selectedRosterSources = locationState.previousScreen.selectedRosterSources;
                    console.log('Found roster sources in previousScreen:', selectedRosterSources);
                }
                
                // Process the found roster sources
                if (selectedRosterSources && selectedRosterSources.length > 0) {
                    // For complete roster source objects (from previous selection)
                    if (selectedRosterSources[0].sourceId && selectedRosterSources[0].sourceName) {
                        initialAddedGroups = selectedRosterSources;
                        console.log('Using complete roster source data');
                    } 
                    // For source IDs only (need to reconstruct the complete objects)
                    else if (sourcesData.length > 0) {
                        // Map IDs to complete objects using our source data
                        initialAddedGroups = selectedRosterSources.map(source => {
                            // Allow for either sourceId as property or direct ID value
                            const sourceId = source.sourceId || source;
                            const matchedSource = sourcesData.find(s => 
                                String(s.sourceId) === String(sourceId));
                            
                            if (matchedSource) {
                                return {
                                    id: String(matchedSource.sourceId),
                                    sourceId: matchedSource.sourceId,
                                    sourceName: matchedSource.sourceName,
                                    providerGroups: matchedSource.providerGroups || 'N/A'
                                };
                            }
                            return null;
                        }).filter(Boolean); // Remove nulls
                        
                        console.log('Reconstructed roster sources from IDs:', initialAddedGroups);
                    }
                }
                
                // Extract just the sourceIds for groupSourceIdList if we don't already have them from the user data
                const initialSourceIds = initialAddedGroups.map(group => String(group.sourceId));
                
                // Update state with the retrieved data
                if (sourcesData.length > 0 || groupIds.length > 0) {
                    // Determine which sourceIds to use - if we're in existingGroup/draftGroup mode and already have user roster sources, use those
                    const sourceIdsToUse = ((this.state.mode === 'existingGroup' || this.state.mode === 'draftGroup') && 
                                           this.state.groupSourceIdList && 
                                           this.state.groupSourceIdList.length > 0) 
                        ? this.state.groupSourceIdList 
                        : initialSourceIds;
                    
                    // Build sourceMap for faster lookups
                    const sourceMap = {};
                    sourcesData.forEach(source => {
                        if (source && source.sourceId !== undefined) {
                            // Store with string key for consistent lookup
                            sourceMap[String(source.sourceId)] = source;
                        }
                    });
                    
                    this.setState({ 
                        //sourceNames: sourceNames,
                        sourcesData: sourcesData,
                        sourceMap: sourceMap, // Store the map in state
                        groupIds: groupIds,
                        groupsData: groupsData,
                        // Only set groupSourceIdList if it's not already populated with user data
                        groupSourceIdList: sourceIdsToUse,
                        loadingMessage: ''
                    }, () => {
                        // State has been updated, now generate the display list
                        // After state is updated, calculate filteredGroupSourceList based on the dynamically generated list
                        const generatedList = this.getGroupSourceList();
                        this.setState({
                            filteredGroupSourceList: this.applySourcesFilters(generatedList, this.state.sourcesFilters)
                        });
                        
                        // Log what was loaded
                        if (this.state.mode === 'existingGroup') {
                            console.log(`Loaded ${this.state.groupSourceIdList.length} roster sources for existing user.`);
                        }
                    });
                } else {
                    this.setState({ 
                        errorMsg: 'No roster sources or source groups found.',
                        loadingMessage: ''
                    });
                }
            })
            .catch((error) => {
                console.log('Error retrieving roster data: ' + error);
                this.setState({ 
                    errorMsg: 'Error: Unable to retrieve roster data. Please try again or contact Customer Service.',
                    loadingMessage: ''
                });
            });
    }

    getUser = () => {
        AuthenticationService.getUsrDtls(AuthenticationService.getLoggedInUserName())
            .then((response) => {
                this.setState({ userDetailsInfo: response.data });
                console.log(`User details: ${JSON.stringify(this.state.userDetailsInfo)}`);
            }).catch(function (error) {
                console.log('Error getting user details: ' + error);
            });
        return true;
    }

    handleCancel = () => {
        //returnPath
        // Navigate back to the previous page (UserSearch)
        if (this.props.location && this.props.location.state) {
            if (this.props.location.state.returnPath) {
                // If we came from UserSearch, go back there with the search info
                this.props.history.push({
                    pathname: this.props.location.state.returnPath,
                    state: {
                        searchInfo: this.props.location.state.searchInfo
                    }
                });
                console.log('Navigating back to ' + this.props.location.state.returnPath);
            } else 
            if (this.props.location.state.searchInfo) {
                // If we came from UserSearch, go back there with the search info
                this.props.history.push({
                    pathname: '/wcpp/UserSearch',
                    state: {
                        searchInfo: this.props.location.state.searchInfo
                    }
                });
                console.log('Navigating back to UserSearch with search info');
            } else if (this.state.mode === 'existingGroup' && this.props.location.state.user) {
                // If we're in existingGroup mode and came directly from user selection
                this.props.history.push({
                    pathname: '/wcpp/UserSearch'
                });
                console.log('Navigating back to UserSearch without search info');
            } else {
                // Default fallback - go to home
                this.props.history.push('/wcpp/home');
                console.log('Navigating to home (default fallback)');
            }
        } else {
            // Default fallback - go to home
            this.props.history.push('/wcpp/home');
            console.log('Navigating to home (no location state)');
        }
    }

    handleBackToAddUser = () => {
        // Navigate back to the AddUser page with the updated roster sources
        const { previousScreen, groupSourceIdList, mode } = this.state;
        const formData = this.props.location.state?.formData || previousScreen || {};
        
        // Generate the current list of selected roster sources
        let rosterSources = [];
        if (groupSourceIdList && groupSourceIdList.length > 0) {
            // Generate the current list with full details needed for display
            const currentList = this.getGroupSourceList();
            rosterSources = currentList.map(group => ({
                id: group.id,
                sourceId: group.sourceId,
                sourceName: group.sourceName,
                providerGroups: group.providerGroups
            }));
            console.log('Roster sources being passed back:', rosterSources);
        } else {
            console.log('No roster sources to pass back');
        }
        
        // Create a clean formData object that preserves the original data
        // but updates the roster sources with current selections
        const updatedFormData = {
            ...formData,
            selectedRosterSources: rosterSources,
            // Preserve the mode (especially important for draft users)
            mode: formData.mode || (mode === 'draftGroup' ? 'draftUser' : 'newUser')
        };
        
        // For draft users, also update groupInfo to include the latest roster sources
        let groupInfo = this.props.location.state?.groupInfo || formData.groupInfo || {};
        
        if (mode === 'draftGroup' || mode === 'existingGroup') {
            groupInfo = {
                ...groupInfo,
                groupRosterSources: rosterSources.map(source => ({
                    sourceId: source.sourceId,
                    sourceName: source.sourceName
                }))
            };
        }
        
        console.log('Navigating back to AddUser with updated formData and groupInfo');
        
        // Preserve the original return path information (typically UserSearch)
        const originalReturnPath = this.props.location?.state?.originalReturnPath || '/wcpp/UserSearch';
        const searchInfo = this.props.location?.state?.searchInfo;
        
        console.log('Preserving original return path when going back to AddUser:', originalReturnPath);
        console.log('Preserving search info for eventual return to UserSearch:', searchInfo);
        
        // Navigate back to AddUser with clean, consistent state structure
        this.props.history.push({
            pathname: '/wcpp/AddUser',
            state: {
                formData: updatedFormData,
                groupInfo: groupInfo,
                // Pass both the older and newer patterns for better compatibility
                addUserFormData: updatedFormData,
                returningFromAddGroup: true,
                // Preserve original navigation path information
                returnPath: originalReturnPath,
                searchInfo: searchInfo,
                // Add timestamp for state detection
                timestamp: new Date().getTime()
            }
        });
    }

    handleSourceNameChange = (event, value) => {
        if (value) {
            this.setState({ 
                selectedSourceName: value, // NOTE: value is now the complete source object
                selectedGroupId: null, // Clear the other selection
                sourceNameError: '',
                groupIdError: '',
                isAddButtonEnabled: true
            });
        } else {
            this.setState({ 
                selectedSourceName: null,
                isAddButtonEnabled: false
            });
        }
    }
    
    handleGroupIdChange = (event) => {
        const value = event.target.value;
        if (value && value.trim() !== '') {
            this.setState({ 
                selectedGroupId: String(value.trim()), // Ensure it's always stored as a string and trimmed
                selectedSourceName: null, // Clear the other selection
                sourceNameError: '',
                groupIdError: '',
                isAddButtonEnabled: true
            });
        } else {
            this.setState({ 
                selectedGroupId: null,
                isAddButtonEnabled: false
            });
        }
    }

    getFormData = () => {
        const { previousScreen, userDetailsInfo, mode } = this.state;
        
        // Validate required data
        if (!previousScreen) {
            throw new Error('Unable to retrieve user details');
        }

        // Handle different data formats based on mode
        let userDetails = {};
        
        // If in existingGroup mode, the previousScreen is the user object from UserSearch
        if (mode === 'existingGroup') {
            // For existing users, we can use the user data directly
            userDetails = {
                id: previousScreen.id,
                userNm: previousScreen.userNm,
                userFirstName: previousScreen.userFirstName,
                userLastName: previousScreen.userLastName,
                userMidName: previousScreen.userMidName || '',
                phoneNum: previousScreen.phoneNum || '',
                emailAddr: previousScreen.emailAddr || '',
                typeCd: previousScreen.typeCd || '',
                jobTitle: previousScreen.jobTitle || '',
                companyNm: previousScreen.companyNm || '',
                mgrUserInfoId: userDetailsInfo ? userDetailsInfo.id : null,
            };
        } else if(mode === 'draftGroup'){ 
            let groupInfo = {};
            const currentRosterSources = this.state.groupSourceIdList.map(sourceId => ({
                sourceId: typeof sourceId === 'object' ? sourceId.sourceId || sourceId.id : sourceId
            }));

            groupInfo = {
                groupInfoId: previousScreen.grpId,
                groupRosterSources: currentRosterSources
            };
            userDetails = {
                id: previousScreen.id,
                isSaveAsDraftOperation: previousScreen.isSaveAsDraftOperation,
                userFirstName: previousScreen.firstName.trim(),
                userLastName: previousScreen.lastName.trim(),
                userMidName: previousScreen.middleInitial.trim(),
                emailAddr: previousScreen.emailAddress.trim(),
                phoneNum: previousScreen.phoneNumber.trim(),
                typeCd: previousScreen.accountType.trim(),
                //grpInfoId: previousScreen.userDetailsInfo.grpInfoId,
                grpInfoId: previousScreen.grpId,
                mgrUserInfoId: previousScreen.mgrUserInfoId,
                statusDesc: previousScreen.userDetailsInfo?.userNm,
                //userFtins:[{"ftin":"160743029"},{"ftin":"231352213"}],
                //userFtins: selectedFtins,
                employeeId: ((previousScreen.enlyteEmpId === "") ? null : previousScreen.enlyteEmpId),
                // Only include affiliation for PRAD, PRUS, and NNUS account types
                affiliationCd: ((previousScreen.accountType === 'ROAD' || previousScreen.accountType === 'ROUS') ? 
                            null : 
                            ((previousScreen.affiliation === "Select One") ? '' : previousScreen.affiliation)),
                affiliationDesc: ((previousScreen.accountType === 'ROAD' || previousScreen.accountType === 'ROUS') ? 
                                null : 
                                previousScreen.other),
                jobTitle: previousScreen.jobTitle,
                companyNm: previousScreen.companyName,
                // Only include companyUrl for account types other than ROAD and ROUS
                companyUrl: (previousScreen.accountType === 'ROAD' || previousScreen.accountType === 'ROUS') ? null : previousScreen.companyUrl,
                // Include group info with roster sources for ROAD and ROUS
                groupInfo: (previousScreen.accountType === 'ROAD' || previousScreen.accountType === 'ROUS') ? groupInfo : undefined,
            };
        } else {
            // For new users, format data as before
            const plainPhoneNm = previousScreen.phoneNumber ? previousScreen.phoneNumber.replace(/[^\d]/g, "") : '';
            userDetails = {
                userFirstName: previousScreen.firstName,
                userLastName: previousScreen.lastName,
                userMidName: previousScreen.midIntl,
                phoneNum: plainPhoneNm,
                emailAddr: previousScreen.emailAddress,
                enlyteEmpId: previousScreen.enlyteEmpId,
                typeCd: previousScreen.accountType,
                jobTitle: previousScreen.jobTitle,
                companyNm: previousScreen.companyName,
                affiliation: previousScreen.affiliation,
                mgrUserInfoId: userDetailsInfo ? userDetailsInfo.id : null,
            };
        }
        
        // Add the userGroupRosterSources from groupSourceIdList directly
        if (this.state.groupSourceIdList && this.state.groupSourceIdList.length > 0) {
            userDetails.userGroupRosterSources = this.state.groupSourceIdList;
        }
        
        return userDetails;
    }
    
    handleSave = (doCompleteProfile) => {
        this.setState({ errorMsg: '', successMsg: '' });
        
        // Validate that user has added at least one group if they're on this screen
        if (this.state.groupSourceIdList.length === 0) {
            this.setState({
                errorMsg: 'You must add at least one roster source before saving as draft'
            });
            return;
        }
        
        try {
            // Set save in progress to disable buttons
            this.setState({ isSaveInProgress: true, loadingMessage: 'Please wait while we save the data.' });
            
            // Get form data from the centralized method
            const userDetails = this.getFormData();

            if (doCompleteProfile) {
                userDetails.completeProfile = true;
            }

            console.log('Saving draft user with roster sources:', userDetails);
            
            // Preserve the original return path information (typically UserSearch)
            const originalReturnPath = this.props.location?.state?.originalReturnPath || '/wcpp/UserSearch';
            const searchInfo = this.props.location?.state?.searchInfo;
            
            // Call the API to save the draft user
            AuthenticationService.saveDraftUser(userDetails)
                .then(response => {
                    if (response.status === 200) {
                        // Show success message and navigate to AddUser page without passing data
                        this.setState({
                            successMsg: 'User has been successfully saved!',
                            errorMsg: '',
                            selectedSourceName: '',
                            selectedSourceId: '',
                            selectedGroupId: '',
                            isAddButtonEnabled: false,
                            sourceNameError: '',
                            groupIdError: '',
                            isSaveInProgress: false, // Re-enable buttons
                            loadingMessage: ''
                        }, () => {
                            // Navigate to AddUser page with success message
                            this.props.history.push({
                                pathname: '/wcpp/AddUser',
                                state: {
                                    returnPath: originalReturnPath, 
                                    searchInfo: searchInfo,
                                    // Include both mode at the top level and in formData for proper detection in AddUser
                                    //mode: 'draftUser',
                                    // Construct a minimal formData object with the mode property to ensure proper restoration
                                    formData: {
                                        mode: this.state.mode === 'newGroup' ? 'newUser' : 'draftUser',
                                        accountType: userDetails.typeCd || 'ROAD'
                                    },
                                    saveDraftSuccess: true, // Flag to indicate successful save
                                    successMsg: 'User has been successfully saved!' // Use successMsg key which AddUser expects
                                }
                            });
                        });
                    } else {
                        // Handle unexpected response status
                        this.setState({ 
                            errorMsg: 'Error: An unexpected error occurred. Please try again or contact Customer Service.',
                            isSaveInProgress: false,
                            loadingMessage: ''
                        });
                    }
                }).catch((error) => {
                    console.error('Error saving draft user:', error);
                    this.setState({ 
                        errorMsg: 'Error: An error occurred while saving the draft user. Please try again or contact Customer Service.',
                        isSaveInProgress: false,
                        loadingMessage: ''
                    });
                });
        } catch (error) {
            console.error('Error preparing form data:', error);
            this.setState({
                errorMsg: error.message || 'Error: Failed to prepare user data',
                isSaveInProgress: false,
                loadingMessage: ''
            });
        }
    }


    handleAddGroup = () => {
        // Validate that either a source name or group ID is entered
        if ((!this.state.selectedSourceName) && 
            (!this.state.selectedGroupId || this.state.selectedGroupId.trim() === '')) {
            this.setState({
                sourceNameError: 'Please select a Roster Hub Source Name or enter a Provider Hub Provider Group ID',
                groupIdError: 'Please select a Roster Hub Source Name or enter a Provider Hub Provider Group ID'
            });
            return;
        }
        
        // Determine which option was selected and create a new group entry
        let newGroup = {};
        
        if (this.state.selectedSourceName) {
            // Find the source data for the selected source name
            // const sourceData = this.state.sourcesData.find(source => 
            //     source.sourceName === this.state.selectedSourceName
            // );
            // Since selectedSourceName is now a complete source object, use it directly
            const sourceData = this.state.selectedSourceName;
            
            newGroup = {
                id: String(sourceData.sourceId), // Unique ID for the row
                sourceId: sourceData.sourceId,
                sourceName: sourceData.sourceName,
                //sourceName: this.state.selectedSourceName,
                providerGroups: 'N/A' // This would be populated with actual provider groups if available
            };
        } else if (this.state.selectedGroupId) {
            // Find the group data for the selected group ID
            // Compare as strings to ensure correct matching
            const groupData = this.state.groupsData.find(group => 
                String(group.grpId) === String(this.state.selectedGroupId)
            );
            if(groupData) {
                // Use the group name from the data if available
                const sourceId = groupData.sourceId; 
                        
                // Use the sourceMap for more efficient lookup
                const sourceData = this.state.sourceMap[String(sourceId)] || 
                    this.state.sourcesData.find(source => source.sourceId === sourceId);
                    
                newGroup = {
                    id: String(sourceId), // Unique ID for the row
                    sourceId: sourceData.sourceId,
                    sourceName: sourceData.sourceName,
                    providerGroups: 'N/A' 
                };  
            }
            else {
                this.setState({
                    errorMsg: `Source "not found for the Provider Hub Provider Group ID : "${this.state.selectedGroupId}" .`,
                    successMsg: '',
                    // Reset selections
                    selectedSourceName: null,
                    selectedGroupId: null,
                    isAddButtonEnabled: false
                });
                return;  
            }
  
        }
        
        // Check if the sourceId already exists in the list
        const sourceIdStr = String(newGroup.sourceId);
        if (this.state.groupSourceIdList.some(id => String(id) === sourceIdStr)) {
            this.setState({
                errorMsg: `Error: The Roster Hub Source "${newGroup.sourceName}" is already associated with this Portal User Group.`,
                successMsg: '',
                // Reset selections
                selectedSourceName: null,
                selectedGroupId: null,
                isAddButtonEnabled: false
            });
            return;
        }

        if(this.props.location.state.mode === 'existingGroup') {
            // First check if we have a valid grpInfoId
            if (!this.state.grpInfoId) {
                console.error('Error: grpInfoId is undefined or null when trying to add source');
                this.setState({
                    errorMsg: 'Error: Unable to add source. Group ID is not available.',
                    successMsg: ''
                });
                return;
            }
            
            console.log('Adding source to group with ID:', this.state.grpInfoId);
            
            // Call the API service and handle state updates inside the promise
            AuthenticationService.addSourceToGroup(this.state.grpInfoId , newGroup.sourceId)
                .then(response => {
                    console.log('Source has been successfully added :', response);
                    const message = `Roster Hub Source "${newGroup.sourceName}" was successfully added to this group.`;
                    
                    // Add the new sourceId to groupSourceIdList array
                    this.setState(prevState => {
                        // Just add the sourceId to the list
                        const updatedSourceIds = [...prevState.groupSourceIdList, newGroup.sourceId];
                        return { 
                            groupSourceIdList: updatedSourceIds,
                            // Reset selections after adding
                            selectedSourceName: null,
                            selectedGroupId: null,
                            isAddButtonEnabled: false,
                            sourcesPage: 0, // Reset to first page when adding a new group
                            successMsg: message,
                            errorMsg: '' // Clear any previous error messages
                        };
                    }, () => {
                        // After state is updated, calculate filteredGroupSourceList based on the dynamically generated list
                        const generatedList = this.getGroupSourceList();
                        this.setState({
                            filteredGroupSourceList: this.applySourcesFilters(generatedList, this.state.sourcesFilters)
                        });
                    });
                })
                .catch(error => {
                    console.error('Error adding source to group:', error);
                    let errorMessage = 'Error: Failed adding source to group. Please try again later.';
                    // Check if there's a more specific error message from the server
                    if (error.response && error.response.data) {
                        errorMessage = `Error: ${error.response.data}`;
                    }
                    this.setState({
                        errorMsg: errorMessage,
                        successMsg: ''
                    });
                });
        } else {
            // For non-existingGroup mode, add the new sourceId to groupSourceIdList array directly
            this.setState(prevState => {
                // Just add the sourceId to the list
                const updatedSourceIds = [...prevState.groupSourceIdList, newGroup.sourceId];
                return { 
                    groupSourceIdList: updatedSourceIds,
                    // Reset selections after adding
                    selectedSourceName: null,
                    selectedGroupId: null,
                    isAddButtonEnabled: false,
                    sourcesPage: 0, // Reset to first page when adding a new group
                    successMsg: '', //`Roster Hub Source "${newGroup.sourceName}" was successfully added to this group.`,
                    errorMsg: '' // Clear any previous error messages
                };
            }, () => {
                // After state is updated, calculate filteredGroupSourceList based on the dynamically generated list
                const generatedList = this.getGroupSourceList();
                this.setState({
                    filteredGroupSourceList: this.applySourcesFilters(generatedList, this.state.sourcesFilters)
                });
            });
        }
    }
    
    handleRemoveGroup = (groupId) => {
        // First, find the sourceId associated with this groupId in the displayed list
        const currentList = this.getGroupSourceList();
        const groupToRemove = currentList.find(group => String(group.id) === String(groupId));
        console.log('Group to remove found:', groupToRemove);
        
        if (!groupToRemove || !groupToRemove.sourceId) {
            console.error('Could not find the source to be removed');
            return;
        }
        
        const sourceIdToRemove = groupToRemove.sourceId;

        if(this.props.location.state.mode === 'existingGroup') {
            // First check if we have a valid grpInfoId
            if (!this.state.grpInfoId) {
                console.error('Error: grpInfoId is undefined or null when trying to remove source');
                this.setState({
                    errorMsg: 'Error: Unable to remove source. Group ID is not available.',
                    successMsg: ''
                });
                return;
            }
            
            console.log('Removing source from group with ID:', this.state.grpInfoId);
            
            // Call the API service
            AuthenticationService.removeSourceFromGroup(this.state.grpInfoId , sourceIdToRemove)
                .then(response => {
                    console.log('Source has been successfully removed!', response);
                    
                    // Remove the sourceId from groupSourceIdList after successful API call
                    this.setState(prevState => {
                        // Filter out the sourceId - using string comparison to ensure consistent matching
                        const updatedSourceIds = prevState.groupSourceIdList.filter(id => String(id) !== String(sourceIdToRemove));
                        
                        console.log('Updated groupSourceIdList:', updatedSourceIds);
                        
                        // Get an updated version of what the list will look like
                        const updatedList = currentList.filter(group => String(group.sourceId) !== String(sourceIdToRemove));
                        
                        // Calculate if we need to adjust the page number (if removing an item from the last page)
                        const totalPages = Math.ceil(updatedList.length / prevState.sourcesRowsPerPage);
                        let newPage = prevState.sourcesPage;
                        
                        // If current page is now empty and it's not the first page, go to previous page
                        if (newPage > 0 && newPage >= totalPages) {
                            newPage = totalPages - 1;
                        }
                        
                        return {
                            groupSourceIdList: updatedSourceIds,
                            sourcesPage: newPage, // Adjust page if necessary
                            successMsg: `Roster Hub Source "${groupToRemove.sourceName}" was successfully removed from this group.`,
                            errorMsg: '' // Clear any previous error messages
                        };
                    }, () => {
                        // After state is updated, calculate filteredGroupSourceList based on the dynamically generated list
                        const generatedList = this.getGroupSourceList();
                        this.setState({
                            filteredGroupSourceList: this.applySourcesFilters(generatedList, this.state.sourcesFilters)
                        });
                    });
                })
                .catch(error => {
                    console.error('Error removing source from group:', error);
                    let errorMessage = 'Error: Failed removing source from group. Please try again later.';
                    this.setState({
                        errorMsg: errorMessage,
                        successMsg: ''
                    });
                });
        } else {
            // For non-existingGroup mode, remove the sourceId directly
            this.setState(prevState => {
                // Debug logs inside setState callback
                console.log('Previous groupSourceIdList:', prevState.groupSourceIdList);
                
                // Filter out the sourceId - using string comparison to ensure consistent matching
                const updatedSourceIds = prevState.groupSourceIdList.filter(id => String(id) !== String(sourceIdToRemove));
                
                console.log('Updated groupSourceIdList:', updatedSourceIds);
                
                // Get an updated version of what the list will look like
                const updatedList = currentList.filter(group => String(group.sourceId) !== String(sourceIdToRemove));
                
                // Calculate if we need to adjust the page number (if removing an item from the last page)
                const totalPages = Math.ceil(updatedList.length / prevState.sourcesRowsPerPage);
                let newPage = prevState.sourcesPage;
                
                // If current page is now empty and it's not the first page, go to previous page
                if (newPage > 0 && newPage >= totalPages) {
                    newPage = totalPages - 1;
                }
                
                return {
                    groupSourceIdList: updatedSourceIds,
                    sourcesPage: newPage, // Adjust page if necessary
                    successMsg:'', // `Roster Hub Source "${groupToRemove.sourceName}" was successfully removed from this group.`,
                    errorMsg: '' // Clear any previous error messages
                };
            }, () => {
                // After state is updated, calculate filteredGroupSourceList based on the dynamically generated list
                const generatedList = this.getGroupSourceList();
                console.log('Generated list after removal:', generatedList);
                
                this.setState({
                    filteredGroupSourceList: this.applySourcesFilters(generatedList, this.state.sourcesFilters)
                });
            });
        }
    }
    
    handleOpenProviderGroupsDialog = (sourceId, sourceName) => {
        // Find all provider groups matching the source ID
        const providerGroups = this.state.groupsData.filter(group => 
            group.sourceId === sourceId
        );
        
        // Reset all filter input fields
        const filterInputs = document.querySelectorAll('.filter-input');
        if (filterInputs) {
            filterInputs.forEach(input => {
                input.value = '';
            });
        }
        
        this.setState({
            isDialogOpen: true,
            currentSourceId: sourceId,
            currentSourceName: sourceName,
            currentProviderGroups: providerGroups,
            filteredProviderGroups: providerGroups, // Initialize filtered groups with all groups
            filters: { // Reset filters
                sourceGroupId: '',
                grpName: '',
                adminGroupFlag: ''
            },
            page: 0, // Reset to first page when opening dialog
            providerGroupOrder: 'asc', // Reset sort order
            providerGroupOrderBy: 'grpId' // Default sort by Provider Group ID
        });
    }
    
    handleCloseProviderGroupsDialog = () => {
        this.setState({
            isDialogOpen: false,
            currentSourceId: null,
            currentSourceName: '',
            currentProviderGroups: [],
            filteredProviderGroups: [],
            filters: {
                sourceGroupId: '',
                grpName: '',
                adminGroupFlag: ''
            },
            page: 0, // Reset to first page when closing dialog
            providerGroupOrder: 'asc', // Reset sort order
            providerGroupOrderBy: 'grpId' // Default sort by Provider Group ID
        });
    }
    
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    }
    
    handleChangeRowsPerPage = (event) => {
        this.setState({ 
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0 // Reset to first page when changing rows per page
        });
    }
    
    handleSourcesChangePage = (event, newPage) => {
        this.setState({ sourcesPage: newPage });
    }
    
    handleSourcesChangeRowsPerPage = (event) => {
        this.setState({ 
            sourcesRowsPerPage: parseInt(event.target.value, 10),
            sourcesPage: 0 // Reset to first page when changing rows per page
        });
    }
    
    handleSourcesFilterChange = (field) => (event) => {
        const value = event.target.value;
        
        this.setState(prevState => {
            const newFilters = {
                ...prevState.sourcesFilters,
                [field]: value
            };
            
            // Generate the current list and apply filters
            const currentList = this.getGroupSourceList();
            const filtered = this.applySourcesFilters(currentList, newFilters);
            
            return {
                sourcesFilters: newFilters,
                filteredGroupSourceList: filtered,
                sourcesPage: 0 // Reset to first page when filtering
            };
        });
    }
    
    applySourcesFilters = (data, filters) => {
        return data.filter(item => {
            // Filter by Roster Hub Source ID (case insensitive partial match)
            if (filters.sourceId && 
                !String(item.sourceId).toLowerCase().includes(filters.sourceId.toLowerCase())) {
                return false;
            }
            
            // Filter by Roster Hub Source Name (case insensitive partial match)
            if (filters.sourceName && 
                !String(item.sourceName).toLowerCase().includes(filters.sourceName.toLowerCase())) {
                return false;
            }
            
            return true;
        });
    }
    
    handleFilterChange = (field) => (event) => {
        const value = event.target.value;
        
        this.setState(prevState => {
            const newFilters = {
                ...prevState.filters,
                [field]: value
            };
            
            // Apply filters to the provider groups
            const filtered = this.applyFilters(prevState.currentProviderGroups, newFilters);
            
            return {
                filters: newFilters,
                filteredProviderGroups: filtered,
                page: 0 // Reset to first page when filtering
            };
        });
    }
    
    applyFilters = (data, filters) => {
        return data.filter(item => {
            // Filter by Provider Group ID (case insensitive partial match)
            if (filters.sourceGroupId && 
                !String(item.sourceGroupId).toLowerCase().includes(filters.sourceGroupId.toLowerCase())) {
                return false;
            }
            
            // Filter by Provider Group Name (case insensitive partial match)
            if (filters.grpName && 
                !String(item.grpName).toLowerCase().includes(filters.grpName.toLowerCase())) {
                return false;
            }
            
            // Filter by Admin Group Flag (exact match)
            if (filters.adminGroupFlag !== '') {
                if (item.adminGroupFlag !== filters.adminGroupFlag) {
                    return false;
                }
            }
            
            return true;
        });
    }

    handleRequestSort = (property) => () => {
        const isAsc = this.state.orderBy === property && this.state.order === 'asc';
        this.setState({
            order: isAsc ? 'desc' : 'asc',
            orderBy: property
        });
    };

    handleProviderGroupRequestSort = (property) => () => {
        const isAsc = this.state.providerGroupOrderBy === property && this.state.providerGroupOrder === 'asc';
        this.setState({
            providerGroupOrder: isAsc ? 'desc' : 'asc',
            providerGroupOrderBy: property
        });
    };

    handleReset = () => {
        if (this.state.mode === 'newGroup' || this.state.mode === 'draftGroup'){
            // Clear all selections and added groups
            this.setState({
                successMsg: '',
                errorMsg: '',
                selectedSourceName: null,
                selectedGroupId: null,
                sourceNameError: '',
                groupIdError: '',
                groupSourceIdList: [], // Only need to reset the ID list
                filteredGroupSourceList: [], // Reset filtered list too
                isAddButtonEnabled: false,
                sourcesPage: 0,
                sourcesFilters: {
                    sourceId: '',
                    sourceName: ''
                }
            }, () => {
                // After clearing the state, also modify the props.location.state to prevent the data
                // from being restored when navigating back to AddUser and then returning here
                if (this.props.location && this.props.location.state) {
                    // Clear selected roster sources from location state to prevent them from being passed back
                    if (this.props.location.state.selectedRosterSources) {
                        this.props.location.state.selectedRosterSources = [];
                    }
                    
                    // If there's a previousScreen object with selectedRosterSources, clear that too
                    if (this.props.location.state.previousScreen && 
                        this.props.location.state.previousScreen.selectedRosterSources) {
                        this.props.location.state.previousScreen.selectedRosterSources = [];
                    }
                    
                    console.log('Reset completed: cleared roster sources from state and navigation data');
                }
            });
        } else {
            // For existingGroup mode, just clear the input fields
            this.setState({
                successMsg: '',
                errorMsg: '',
                selectedSourceName: null,
                selectedGroupId: null,
                sourceNameError: '',
                groupIdError: '',
                isAddButtonEnabled: false
            });
            console.log('Reset completed: cleared input fields only');
        }
        // Show confirmation message
        //this.setState({ successMsg: 'Form has been reset successfully!' });
    }
    
    showSuccessErrorMessage = () => {
        return (
            <>
                <LoadingMsgBar loadMsg={this.state.loadingMessage} />
                <GlobalMessage message={this.state.errorMsg} />
                <GlobalMessage type='success' message={this.state.successMsg} />
            </>
        );
    }
    showHedding =() =>{
        if(this.props.location.state.mode === 'existingGroup') {
            let groupIdDisplay = 'Unknown';
            
            // First try to get the ID from state
            if (this.state.grpInfoId) {
                groupIdDisplay = this.state.grpInfoId;
            }
            // If not in state, try to get from props
            else if (this.props.location.state.groupInfo) {
                if (this.props.location.state.groupInfo.groupInfoId) {
                    groupIdDisplay = this.props.location.state.groupInfo.groupInfoId;
                } else if (this.props.location.state.groupInfo.grpInfoId) {
                    groupIdDisplay = this.props.location.state.groupInfo.grpInfoId;
                }
            }
            
            return (<h1 className='App-page-label'>Manage Roster Hub Sources For User Group {groupIdDisplay}</h1>);
        }
        return (<h1 className='App-page-label'>Add User </h1>);
    }
    
    showButtons = () => {
        // Only show the button row when mode is 'newGroup'
        if (this.state.mode !== 'newGroup' && this.state.mode !== 'draftGroup') {
            return null;
        }
        
        // doCompleteProfile is not defined in this context, so we'll remove references to it
        
        return (
            <nav>
                <Button 
                    color="primary" 
                    variant="contained"
                    onClick={() => this.handleSave(true)}
                    disabled={this.state.isSaveInProgress}
                    className={this.props.classes.button}
                >
                    COMPLETE PROFILE
                </Button>
                <Button 
                    color="primary" 
                    onClick={() => this.handleSave(false)}
                    disabled={this.state.isSaveInProgress}
                    className={this.props.classes.button}
                >
                    SAVE AS DRAFT
                </Button>
                <Button 
                    variant="outlined" 
                    onClick={this.handleBackToAddUser}
                    disabled={this.state.isSaveInProgress}
                    className={this.props.classes.button}
                >
                    BACK
                </Button>
                <Button 
                    color="secondary" 
                    variant="outlined"
                    onClick={this.handleReset}
                    disabled={this.state.isSaveInProgress}
                    className={this.props.classes.button}
                >
                    RESET
                </Button>
            </nav>
        );
    }

    render() {
        const { classes } = this.props;
        const { 
            previousScreen, 
            //sourceNames, 
            selectedSourceName,
            groupIds, selectedGroupId,
            sourceNameError, groupIdError,
            mode
        } = this.state;

        // Debug log to confirm which mode we're in
        console.log('Current mode in render:', mode);

        return (
            <div className='App-content ManageRosterSourcesForUserGroup'>       
                {this.showHedding()}
                {this.showSuccessErrorMessage()}
                <div className="step-main">
                    <Grid container direction="column" className={classes.container}>
                        <Grid item style={{ width: '100%', textAlign: 'left' }}>
                           
                            <Grid container spacing={3} alignItems="center">
                                <Grid item xs={12} md={5} className={classes.formField}>
                                    <Autocomplete
                                        id="source-name-select"
                                        options={this.state.sourcesData.filter(source => source.sourceName).sort((a, b) => a.sourceName.localeCompare(b.sourceName))}
                                        value={this.state.selectedSourceName}
                                        onChange={this.handleSourceNameChange}                                        
                                        getOptionLabel={(option) => {
                                            if (typeof option === 'object' && option !== null) {
                                                return `${option.sourceName} (${option.sourceId})`;
                                            }
                                            return option || '';
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Roster Hub Source Name *"
                                                variant="outlined"
                                                helperText={this.state.sourceNameError}
                                                error={Boolean(this.state.sourceNameError)}
                                                FormHelperTextProps={{
                                                    style: { color: '#B0170C' }
                                                }}
                                            />
                                        )}
                                        fullWidth
                                    />
                                </Grid>
                                
                                <Grid item xs={12} md={1} className={classes.orText}>
                                    OR
                                </Grid>
                                
                                <Grid item xs={12} md={5} className={classes.formField}>
                                    <TextField
                                        id="group-id-input"
                                        label="Provider Hub Provider Group ID *"
                                        variant="outlined"
                                        value={this.state.selectedGroupId || ''}
                                        onChange={this.handleGroupIdChange}
                                        error={Boolean(this.state.groupIdError)}
                                        helperText={this.state.groupIdError}
                                        FormHelperTextProps={{
                                            style: { color: '#B0170C' }
                                        }}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Button 
                                        variant="contained" 
                                        color="primary" 
                                        onClick={this.handleAddGroup}
                                        disabled={!this.state.isAddButtonEnabled}
                                        className={classes.addButton}
                                        style={{ marginRight: '10px' }}
                                    >
                                        ADD
                                    </Button>
                                    
                                    {this.state.mode === 'existingGroup' && (
                                        <>
                                            <Button 
                                                variant="outlined"
                                                onClick={this.handleReset}
                                                className={classes.button}
                                                style={{ marginRight: '10px' }}
                                            >
                                                RESET
                                            </Button>
                                            <Button 
                                                variant="outlined"
                                                onClick={this.handleCancel}
                                                className={classes.button}
                                            >
                                                CANCEL
                                            </Button>
                                        </>
                                    )}
                                </Grid>

                                <Grid item xs={12}>
                                    {this.state.groupSourceIdList.length > 0 && (
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25]}
                                            component="div"
                                            count={this.state.filteredGroupSourceList.length}
                                            rowsPerPage={this.state.sourcesRowsPerPage}
                                            page={this.state.sourcesPage}
                                            onChangePage={this.handleSourcesChangePage}
                                            onChangeRowsPerPage={this.handleSourcesChangeRowsPerPage}
                                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} of ${count}`}
                                            labelRowsPerPage={"Rows per page:"}
                                            className={classes.topPagination}
                                        />
                                    )}
                                    <TableContainer component={Paper} className={classes.tableContainer}>
                                        <Table aria-label="roster hub sources table">
                                            <TableHead className={classes.tableHeader}>
                                                <TableRow>
                                                    <TableCell className={classes.headerCell}>
                                                        <TableSortLabel
                                                            active={this.state.orderBy === 'sourceId'}
                                                            direction={this.state.orderBy === 'sourceId' ? this.state.order : 'asc'}
                                                            onClick={this.handleRequestSort('sourceId')}
                                                        >
                                                            Roster Hub Source ID
                                                        </TableSortLabel>
                                                    </TableCell>
                                                    <TableCell className={classes.headerCell}>
                                                        <TableSortLabel
                                                            active={this.state.orderBy === 'sourceName'}
                                                            direction={this.state.orderBy === 'sourceName' ? this.state.order : 'asc'}
                                                            onClick={this.handleRequestSort('sourceName')}
                                                        >
                                                            Roster Hub Source Name
                                                        </TableSortLabel>
                                                    </TableCell>
                                                    <TableCell className={classes.headerCell}>Provider Hub Provider Groups</TableCell>
                                                    <TableCell className={classes.headerCell} align="center">Remove</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow className={classes.filterRow}>
                                                    <TableCell className={classes.filterCell}>
                                                        <TextField 
                                                            variant="outlined"
                                                            size="small"
                                                            placeholder="Filter ..."
                                                            fullWidth
                                                            onChange={this.handleSourcesFilterChange('sourceId')}
                                                            className="filter-input"
                                                            value={this.state.sourcesFilters.sourceId}
                                                        />
                                                    </TableCell>
                                                    <TableCell className={classes.filterCell}>
                                                        <TextField 
                                                            variant="outlined"
                                                            size="small"
                                                            placeholder="Filter ..."
                                                            fullWidth
                                                            onChange={this.handleSourcesFilterChange('sourceName')}
                                                            className="filter-input"
                                                            value={this.state.sourcesFilters.sourceName}
                                                        />
                                                    </TableCell>
                                                    <TableCell className={classes.filterCell}>
                                                        {/* Placeholder for Provider Hub Provider Groups column */}
                                                    </TableCell>
                                                    <TableCell className={classes.filterCell} align="center">
                                                        {/* Placeholder for Remove column */}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                            <TableBody>
                                                {this.state.filteredGroupSourceList.length > 0 ? (
                                                    (this.state.sourcesRowsPerPage > 0
                                                        ? stableSort(
                                                            this.state.filteredGroupSourceList,
                                                            getComparator(this.state.order, this.state.orderBy)
                                                          ).slice(
                                                            this.state.sourcesPage * this.state.sourcesRowsPerPage,
                                                            this.state.sourcesPage * this.state.sourcesRowsPerPage + this.state.sourcesRowsPerPage
                                                        )
                                                        : stableSort(
                                                            this.state.filteredGroupSourceList,
                                                            getComparator(this.state.order, this.state.orderBy)
                                                          )
                                                    ).map((group) => (
                                                        <TableRow key={group.id}>
                                                            <TableCell className={classes.tableCell}>{group.sourceId}</TableCell>
                                                            <TableCell className={classes.tableCell}>{group.sourceName}</TableCell>
                                                            <TableCell className={classes.tableCell}>
                                                                <Link 
                                                                    component="button"
                                                                    variant="body2"
                                                                    onClick={() => this.handleOpenProviderGroupsDialog(group.sourceId, group.sourceName)}
                                                                    color="primary"
                                                                    className={classes.viewLink}
                                                                >
                                                                    View Provider Hub Provider Groups
                                                                </Link>
                                                            </TableCell>
                                                            <TableCell className={classes.tableCell} align="center">
                                                                <IconButton 
                                                                    aria-label="remove"
                                                                    onClick={() => {
                                                                        console.log('Delete clicked for row with id:', group.id, 'sourceId:', group.sourceId);
                                                                        this.handleRemoveGroup(group.id);
                                                                    }}
                                                                >
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={4} className={classes.noDataMessage}>
                                                            {this.state.groupSourceIdList.length > 0 ? 
                                                                'No matching results found. Try adjusting your filters.' : 
                                                                'No groups have been added yet.'}
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    {this.state.groupSourceIdList.length > 0 && (
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25]}
                                            component="div"
                                            count={this.state.filteredGroupSourceList.length}
                                            rowsPerPage={this.state.sourcesRowsPerPage}
                                            page={this.state.sourcesPage}
                                            onChangePage={this.handleSourcesChangePage}
                                            onChangeRowsPerPage={this.handleSourcesChangeRowsPerPage}
                                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} of ${count}`}
                                            labelRowsPerPage={"Rows per page:"}
                                            className={classes.pagination}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>

                {this.showButtons()}

                {/* Provider Groups Dialog */}
                <Dialog
                    open={this.state.isDialogOpen}
                    onClose={this.handleCloseProviderGroupsDialog}
                    aria-labelledby="provider-groups-dialog-title"
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle id="provider-groups-dialog-title" className={classes.dialogTitle}>
                        Provider Hub Provider Groups of Roster Hub Source {this.state.currentSourceName}
                    </DialogTitle>
                    <DialogContent>
                        {this.state.filteredProviderGroups.length > 0 && (
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={this.state.filteredProviderGroups.length}
                                rowsPerPage={this.state.rowsPerPage}
                                page={this.state.page}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} of ${count}`}
                                labelRowsPerPage={"Rows per page:"}
                                className={classes.topPagination}
                            />
                        )}
                        <TableContainer component={Paper}>
                            <Table aria-label="provider groups table">
                                <TableHead className={classes.tableHeader}>
                                    <TableRow>
                                        <TableCell className={classes.headerCell}>
                                            <TableSortLabel
                                                active={this.state.providerGroupOrderBy === 'grpId'}
                                                direction={this.state.providerGroupOrderBy === 'grpId' ? this.state.providerGroupOrder : 'asc'}
                                                onClick={this.handleProviderGroupRequestSort('grpId')}
                                            >
                                                Provider Group ID
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell className={classes.headerCell}>
                                            <TableSortLabel
                                                active={this.state.providerGroupOrderBy === 'grpName'}
                                                direction={this.state.providerGroupOrderBy === 'grpName' ? this.state.providerGroupOrder : 'asc'}
                                                onClick={this.handleProviderGroupRequestSort('grpName')}
                                            >
                                                Provider Group Name
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell className={classes.headerCell}>
                                            <TableSortLabel
                                                active={this.state.providerGroupOrderBy === 'adminGroupFlag'}
                                                direction={this.state.providerGroupOrderBy === 'adminGroupFlag' ? this.state.providerGroupOrder : 'asc'}
                                                onClick={this.handleProviderGroupRequestSort('adminGroupFlag')}
                                            >
                                                Admin Group Flag
                                            </TableSortLabel>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow className={classes.filterRow}>
                                        <TableCell className={classes.filterCell}>
                                            <TextField 
                                                variant="outlined"
                                                size="small"
                                                placeholder="Filter .."
                                                fullWidth
                                                onChange={this.handleFilterChange('sourceGroupId')}
                                                className="filter-input"
                                            />
                                        </TableCell>
                                        <TableCell className={classes.filterCell}>
                                            <TextField 
                                                variant="outlined"
                                                size="small"
                                                placeholder="Filter .."
                                                fullWidth
                                                onChange={this.handleFilterChange('grpName')}
                                                className="filter-input"
                                            />
                                        </TableCell>
                                        <TableCell className={classes.filterCell}>
                                            <TextField
                                                select
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                placeholder="Filter .."
                                                onChange={this.handleFilterChange('adminGroupFlag')}
                                                className="filter-input"
                                                SelectProps={{
                                                    native: true
                                                }}
                                                value={this.state.filters.adminGroupFlag}
                                            >
                                                <option value="">All</option>
                                                <option value="Y">Yes</option>
                                                <option value="N">No</option>
                                            </TextField>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                                <TableBody>
                                    {this.state.filteredProviderGroups.length > 0 ? (
                                        (this.state.rowsPerPage > 0
                                            ? stableSort(
                                                this.state.filteredProviderGroups,
                                                getComparator(this.state.providerGroupOrder, this.state.providerGroupOrderBy)
                                              ).slice(
                                                this.state.page * this.state.rowsPerPage,
                                                this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
                                              )
                                            : stableSort(
                                                this.state.filteredProviderGroups,
                                                getComparator(this.state.providerGroupOrder, this.state.providerGroupOrderBy)
                                              )
                                        ).map((group, index) => (
                                            <TableRow key={index}>
                                                <TableCell className={classes.tableCell}>{group.grpId}</TableCell>
                                                <TableCell className={classes.tableCell}>{group.grpName}</TableCell>
                                                <TableCell className={classes.tableCell}>
                                                    {group.adminGroupFlag == 'Y' ? 'Yes' : 'No'}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={3} className={classes.noDataMessage}>
                                                {this.state.currentProviderGroups.length > 0 ? 
                                                    'No matching results found. Try adjusting your filters.' : 
                                                    'No provider groups found for this source.'}
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                            {this.state.filteredProviderGroups.length > 0 && (
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={this.state.filteredProviderGroups.length}
                                    rowsPerPage={this.state.rowsPerPage}
                                    page={this.state.page}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} of ${count}`}
                                    labelRowsPerPage={"Rows per page:"}
                                    className={classes.pagination}
                                />
                            )}
                        </TableContainer>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseProviderGroupsDialog} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default withStyles(styles)(ManageRosterSourcesForUserGroup);
